<div class="py-2 px-3">
    <h1 mat-dialog-title>
        {{ data.isPolicyActive ? 'Deactivate' : 'Activate' }} Policy
    </h1>
    <div class="p-2">
        <div mat-dialog-content *ngIf="!data.isPolicyInUse">
            <div>Are you sure you would like to proceed?</div>
        </div>
        <div mat-dialog-content *ngIf="data.isPolicyInUse">
            <div>Unable to {{ data.isPolicyActive ? 'deactivate' : 'activate' }} Policy as it is currently assigned to an Organization, Property and/or Underwriter.</div>
        </div>
    </div>
    <div class="mt-4 mb-3 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" (click)="onCancelClick()">
            Cancel
        </button>
        @if(data.isPolicyActive) {
            <button mat-raised-button class="warn-button" (click)="onConfirmClick()" [disabled]="data.isPolicyInUse">
                Deactivate
            </button>
        }
        @if(!data.isPolicyActive) {
            <button mat-raised-button class="action-button" (click)="onConfirmClick()" [disabled]="data.isPolicyInUse">
                Activate
            </button>
        }
    </div>
</div>